import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import Testing from "./sections/Testing";
import WhyProfessionalTestingMatters from "./sections/WhyProfessionalTestingMatters";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <Testing />
      <WhyProfessionalTestingMatters />
      <Inquiries />
      <Footer />
    </div>;
}